module.exports = __webpack_public_path__ + "static/media/8768.c97db0c8.png";